import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getRentalUtilization(params) {
        const response = await axios.get(API_URL + "/rental-utilization", { headers: authHeader(), params: params });
        return { data: response.data, meta: response.data.meta?.page };
    },
}




